import { render, staticRenderFns } from "./roles_list.vue?vue&type=template&id=e8220894"
import script from "./roles_list.vue?vue&type=script&lang=js"
export * from "./roles_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports